/* Keep Brooklyn's slider and drawer implementation; only adapt homepage motion. */
(function () {
  'use strict';
  var motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  function respectMotion(root) {
    if (!motion.matches || !window.jQuery) return;
    window.jQuery(root).find('.hero.slick-initialized').each(function () {
      var slider = window.jQuery(this);
      slider.slick('slickPause');
      slider.slick('slickSetOption', 'speed', 0, false);
      var pause = slider.find('[data-pause]');
      pause.addClass('is-paused').attr('aria-label', pause.attr('data-label-play'));
    });
  }
  function init() { respectMotion(document); }
  if (window.jQuery) {
    window.jQuery(document).on('init.merisiMotion reInit.merisiMotion', '.hero', function (event, slick) {
      slick.slickSetOption('focusOnChange', false, false);
      if (!motion.matches) return;
      slick.slickSetOption('autoplay', false, false);
      slick.slickSetOption('speed', 0, false);
      slick.slickPause();
      window.requestAnimationFrame(init);
    });
  }
  window.addEventListener('load', init);
  if (document.readyState === 'complete') init();
  document.addEventListener('shopify:section:load', function () { window.requestAnimationFrame(init); });
  document.addEventListener('shopify:block:deselect', function () { window.requestAnimationFrame(init); });
  if (motion.addEventListener) motion.addEventListener('change', init);
})();
